export default "__VITE_ASSET__Bbstoj$o__"